module.exports = __webpack_public_path__ + "media/images/bottles/bottle-rouge-898da5ad90edae41d9484f30a71385f1.png";